import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWR from "swr";

const getTasks = async (params) => jwtAxios.get(URL_API.CMS_TASKS.GET_TASKS, { params });

const useGetTasks = (params) => {
	const fetcher = () => getTasks(params);
	const key = { url: URL_API.CMS_TASKS.GET_TASKS, params, tags: ["#tasks"] };
	const swr = useSWR(key, fetcher);

	const refetch = async () => {
		if (swr.mutate) return swr.mutate();
		return null;
	};

	return { ...swr, refetch };
};

export default useGetTasks;
